import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { DocumentDto } from 'projects/shared/src/lib/models/DocumentDto';
import { AttributeValueService } from 'projects/shared/src/lib/services/attribute-value.service';
import { DataSharingService } from 'projects/shared/src/lib/services/data-sharing.service';
import { ValueConfAttributeService } from 'projects/shared/src/lib/services/value-conf-attribute.service';

@Component({
  selector: 'generic-form',
  templateUrl: './generic-form.component.html',
  styleUrls: ['./generic-form.component.scss']
})
export class GenericFormComponent implements OnInit {

  @Input('pagedId') pagedId! : string;  

  form = new FormGroup({});
  model: any = {};
  fields: FormlyFieldConfig[] = [];

  documentDto!: DocumentDto;

  totalRecords = 0;
  currentPage = 1;
  pageSize = 10

  dbName!: string;
  pageId!: string;
  tabId!: string;

  errorMessage!: string;

  constructor(private route: ActivatedRoute,
    private dataSharingService: DataSharingService,
    private valueConfAttributeService: ValueConfAttributeService,
    private attributeValueService: AttributeValueService,
  ) { }  
  

  ngOnInit(): void {
    this.dbName = localStorage.getItem('dbname') as string;
    let id = localStorage.getItem('doc-id') as string; 
    
   localStorage.setItem('page-id', this.pagedId);

  // Todo: just pass only the documentId 
    this.attributeValueService.loadCurrentAttributeValue('', id, this.pagedId, this.currentPage, this.pageSize, this.dbName).subscribe({
      next: (currentAttributeValueDto) => {
        this.model = JSON.parse(currentAttributeValueDto.controlData);
        //--console.log(currentAttributeValueDto.controlData)
      },
      //error: error => this.errorMessage = ErrorFormat.formatError(error)
    });

    this.valueConfAttributeService.getNgxFormlyForms(this.pagedId, this.dbName).subscribe({
      next: (ngxFormlyFormFields: any) => {
        this.fields = ngxFormlyFormFields;
       //--- console.log(ngxFormlyFormFields)
      }
    });
  }


  onSubmit(form: any) {
    console.log(form);
  }
}
